module.exports = __webpack_public_path__ + "static/media/th.0a15245b.webp";